import { FaRegCopy } from 'react-icons/fa';
import { Button } from '../../../../../../../components/button/button';
import { Collapse } from '../../../../../../../components/collapse/collapse';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useAlertStore } from '../../../../../../../store/use-alert-store';
import s from './menu-informer-ai-prompt.module.css';

const format = [
  'CSV',
  "разделитель между полями – точка с запятой ';'",
  'первая строка – техническое название полей, можно пропускать',
  'максимальный размер файла – 8мб',
];

const fields = [
  'Номер по порядку, целое число',
  "'Раздел ru' на русском языке (пример – кухня, бар), текст",
  "'Раздел kz' на казахском, текст",
  "'Раздел en' на английском, текст",
  "'Раздел ch' на китайском, текст",
  "'Категория ru' на русском языке (пример – завтраки, горячее, напитки), текст",
  "'Категория kz' на казахском, текст",
  "'Категория en' на английском, текст",
  "'Категория ch' на китайском, текст",
  "'Наименование ru' на русском языке (пример – кофе, лагман, морс в ассортименте), текст",
  "'Наименование kz' на казахском, текст",
  "'Наименование en' на английском, текст",
  "'Наименование ch' на китайском, текст",
  "'Описание ru' на русском языке (пример – Двойная порция классического эспрессо, смягченная добавлением горячей воды), текст",
  "'Описание kz' на казахском языке, текст",
  "'Описание en' на английском языке, текст",
  "'Описание ch' на китайском языке, текст",
  "'Стоимость' в тенге, число с 2 знаками после запятой",
  "'Вес(кг) / Объем(л)' в кг или объем в литрах, число",
 
];

export const MenuInformerAiPrompt = () => {
  const { t } = useLang();
  const { add } = useAlertStore();

  const renderList = (list: string[]) => (
    <ul className={s.list}>
      {list.map((item) => (
        <li key={item} className={s.item}>
          {t(item)}
        </li>
      ))}
    </ul>
  );

  const handleCopy = async () => {
    try {
      const text = [`${t('Формат')}:`, ...format, `${t('Поля')}:`, ...fields].join('\n');
      await navigator.clipboard.writeText(text);
      add({ label: t('Скопировано'), variant: 'success' });
    } catch (error) {
      add({ label: t('Ошибка копирования'), variant: 'danger' });
    }
  };

  return (
    <Collapse
      wrapperClassname={s.feature}
      header={t('Шаблон для промпта в ИИ')}
      motionKey="prompt"
      children={
        <div className={s.children}>
          <div className={s.header}>
            <div className={s.title}>{t('Скопируйте данный текст')}</div>
            <Button variant="ghost" className={s.copy} onClick={handleCopy}>
              <FaRegCopy />
              {t('Скопировать')}
            </Button>
          </div>

          <div>
            <div className={s.title}>{t('Формат')}:</div>
            {renderList(format)}
          </div>

          <div>
            <div className={s.title}>{t('Поля')}:</div>
            {renderList(fields)}
          </div>
        </div>
      }
    />
  );
};
